(function () {
  "use strict";

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  const root = $(".itinerary-quiz");
  if (!root) return;

  const CITIES_URL = root.dataset.citiesUrl;
  const LANDMARKS_URL = root.dataset.landmarksUrl;

  const wrapper = $(".slides-wrapper", root);
  const slidesEl = $(".slides", root);
  const slidesArr = $$(".slide", slidesEl);
  const progressBar = $(".iq-progress__bar", root);
  const progressText = $(".iq-progress__text", root);
  const progressLabel = $(".iq-progress__label", root);

  let currentIndex = 0;
  let answers = {};

  // ========== [ Start of Search Index Util] ==========
  const norm = (s) =>
    s
      .toLowerCase()
      .normalize("NFD")
      .replace(/\p{Diacritic}/gu, "")
      .replace(/\s+/g, " ")
      .trim();

  function debounce(fn, ms = 200) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), ms);
    };
  }

  // cache & controller per tipe
  const DATA_CACHE = { city: null, landmark: null };
  const INDEX_CACHE = { city: null, landmark: null };
  const CONTROLLER = { city: null, landmark: null };

  async function loadType(type, url) {
    if (DATA_CACHE[type]) return DATA_CACHE[type];
    if (CONTROLLER[type]) CONTROLLER[type].abort();
    const ctrl = new AbortController();
    CONTROLLER[type] = ctrl;
    const res = await fetch(url, { signal: ctrl.signal, cache: "force-cache" });
    if (!res.ok) throw new Error("Failed to load " + type);
    const json = await res.json();
    DATA_CACHE[type] = json;
    return json;
  }

  function buildIndex(type, raw) {
    const list = [];
    const keys = [];
    const prefix2 = new Map();
    const prefix3 = new Map();

    const pushIdx = (map, key, i) => {
      if (!key) return;
      const arr = map.get(key) || [];
      arr.push(i);
      map.set(key, arr);
    };

    if (type === "city") {
      raw.forEach((label) => {
        const L = String(label || "").trim();
        if (!L) return;
        const i = list.length;
        list.push({ l: L });
        const k = [norm(L)];
        keys.push(k);
        const p2 = k[0].slice(0, 2),
          p3 = k[0].slice(0, 3);
        pushIdx(prefix2, p2, i);
        pushIdx(prefix3, p3, i);
      });
    } else {
      raw.forEach((o) => {
        const L = String(o?.l || "").trim();
        if (!L) return;
        const i = list.length;
        list.push({ l: L, a: o.a || [] });
        const kw = [L, ...(o.a || [])].map(norm).filter(Boolean);
        const uniq = Array.from(new Set(kw));
        keys.push(uniq);
        const p2 = uniq[0]?.slice(0, 2),
          p3 = uniq[0]?.slice(0, 3);
        pushIdx(prefix2, p2, i);
        pushIdx(prefix3, p3, i);
      });
    }

    INDEX_CACHE[type] = { list, keys, prefix2, prefix3 };
    return INDEX_CACHE[type];
  }

  async function ensureIndex(type, url) {
    if (INDEX_CACHE[type]) return INDEX_CACHE[type];
    const raw = await loadType(type, url);
    return buildIndex(type, raw);
  }

  async function searchType(type, url, q, limit = 20) {
    const idx = await ensureIndex(type, url);
    const n = norm(q);
    if (n.length < 2) return [];
    const { list, keys, prefix2, prefix3 } = idx;

    const b3 = prefix3.get(n.slice(0, 3)) || [];
    const b2 = prefix2.get(n.slice(0, 2)) || [];
    const pool = b3.length ? b3 : b2.length ? b2 : keys.map((_, i) => i);

    const pref = [];
    const sub = [];
    for (const i of pool) {
      if (keys[i].some((k) => k.startsWith(n))) {
        pref.push(i);
        if (pref.length >= limit) break;
      }
    }
    if (pref.length < limit) {
      for (const i of pool) {
        if (pref.includes(i)) continue;
        if (keys[i].some((k) => k.includes(n))) {
          sub.push(i);
          if (pref.length + sub.length >= limit) break;
        }
      }
    }

    const picked = [...pref, ...sub].slice(0, limit);
    return picked.map((i) => list[i].l);
  }
  // ========== [ End of Search Index Util ] ==========

  // ===== DATA UNTUK FOTO CITY DAN LANDMARK =====
  const cityData = [
    {
      name: "Tokyo",
      img: "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/itin-tokyo_city.png?v=1760343969",
    },
    {
      name: "Osaka",
      img: "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/itin-osaka_city.png?v=1760344908",
    },
    {
      name: "Kyoto",
      img: "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/itin-kyoto_city.png?v=1760344908",
    },
    {
      name: "Nara",
      img: "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/itin-nara_city.png?v=1760344946",
    },
    {
      name: "Hiroshima",
      img: "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/itin-hiroshima_city.png?v=1760344946",
    },
    {
      name: "Fukuoka",
      img: "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/itin-fukuoka_city.png?v=1760344985",
    },
    {
      name: "Sapporo",
      img: "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/itin-sapporo_city.png?v=1760344984",
    },
    {
      name: "Fujikawaguchiko",
      img: "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/itin-fuji-kawahguchiko.png?v=1760345793",
    },
    {
      name: "Kanazawa",
      img: "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/itin-kanazawa_city.png?v=1760345023",
    },
  ];

  const landmarkData = [
    {
      name: "Tokyo Disneyland",
      img: "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/itin-tokyo-disneyland.png?v=1760345837",
    },
    {
      name: "Tokyo DisneySea",
      img: "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/itin-tokyo_disneysea.png?v=1760345224",
    },
    {
      name: "Universal Studios Japan",
      img: "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/itin-universal_studios_japan.png?v=1760345224",
    },
    {
      name: "Tokyo Tower",
      img: "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/itin-tokyo_tower.png?v=1760345224",
    },
    {
      name: "Tokyo Skytree",
      img: "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/itin-tokyo_skytree.png?v=1760345224",
    },
    {
      name: "Warner Bros Tour Tokyo",
      img: "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/itin-wb-tokyo-tour.png?v=1760345950",
    },
    {
      name: "Kiyomizu-dera",
      img: "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/itin-kiyomizudera.png?v=1760345223",
    },
    {
      name: "Kinkaku-ji",
      img: "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/itin-kinkakuji.png?v=1760345224",
    },
    {
      name: "Hiroshima Peace Memorial",
      img: "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/itin-kanazawa_city.png?v=1760345023",
    },
  ];

  // ✅ Superset untuk autocomplete (bisa dari JSON Assets)
  let CITY_ALL = [];
  let LANDMARK_ALL = [];

  async function loadAutoCompleteUniverse(rootEl) {
    const citiesUrl = rootEl?.dataset?.citiesUrl;
    const landmarksUrl = rootEl?.dataset?.landmarksUrl;

    // Fallback daftar tambahan jika tidak ada JSON Assets (isi sesuai kebutuhanmu)
    const DEFAULT_CITY_LIST = [
      "Sapporo",
      "Hakodate",
      "Otaru",
      "Asahikawa",
      "Muroran",
      "Kushiro",
      "Obihiro",
      "Kitami",
      "Yubari",
      "Iwamizawa",
      "Abashiri",
      "Rumoi",
      "Tomakomai",
      "Wakkanai",
      "Bibai",
      "Ashibetsu",
      "Ebetsu",
      "Akabira",
      "Monbetsu",
      "Shibetsu",
      "Nayoro",
      "Mikasa",
      "Nemuro",
      "Chitose",
      "Takikawa",
      "Sunagawa",
      "Utashinai",
      "Fukagawa",
      "Furano",
      "Noboribetsu",
      "Eniwa",
      "Date",
      "Kitahiroshima",
      "Ishikari",
      "Hokuto",
      "Tobetsu",
      "Shinshinotsu",
      "Matsumae",
      "Fukushima",
      "Shiriuchi",
      "Kikonai",
      "Nanae",
      "Shikabe",
      "Mori",
      "Yakumo",
      "Oshamanbe",
      "Esashi",
      "Kaminokuni",
      "Assabu",
      "Otobe",
      "Okushiri",
      "Imakane",
      "Setana",
      "Shimamaki",
      "Suttsu",
      "Kuromatsunai",
      "Rankoshi",
      "Niseko",
      "Makkari",
      "Rusutsu",
      "Kimobetsu",
      "Kyogoku",
      "Kutchan",
      "Kyowa",
      "Iwanai",
      "Tomari",
      "Kamoenai",
      "Shakotan",
      "Furubira",
      "Niki",
      "Yoichi",
      "Akaigawa",
      "Nanporo",
      "Naie",
      "Kamisunagawa",
      "Yuni",
      "Naganuma",
      "Kuriyama",
      "Tsukigata",
      "Urausu",
      "Shintotsukawa",
      "Moseushi",
      "Chippubetsu",
      "Uryu",
      "Hokuryu",
      "Numata",
      "Takasu",
      "Higashikagura",
      "Toma",
      "Pippu",
      "Aibetsu",
      "Kamikawa",
      "Higashikawa",
      "Biei",
      "Kamifurano",
      "Nakafurano",
      "Minamifurano",
      "Shimukappu",
      "Wassamu",
      "Kenbuchi",
      "Shimokawa",
      "Bifuka",
      "Otoineppu",
      "Nakagawa",
      "Horokanai",
      "Mashike",
      "Obira",
      "Tomamae",
      "Haboro",
      "Shosanbetsu",
      "Enbetsu",
      "Teshio",
      "Sarufutsu",
      "Hamatonbetsu",
      "Nakatonbetsu",
      "Toyotomi",
      "Rebun",
      "Rishiri",
      "Rishirifuji",
      "Horonobe",
      "Bihoro",
      "Tsubetsu",
      "Shari",
      "Kiyosato",
      "Koshimizu",
      "Kunneppu",
      "Oketo",
      "Saroma",
      "Engaru",
      "Yubetsu",
      "Takinoue",
      "Okoppe",
      "Nishiokoppe",
      "Omu",
      "Ozora",
      "Toyoura",
      "Sobetsu",
      "Shiraoi",
      "Atsuma",
      "Toyako",
      "Abira",
      "Mukawa",
      "Hidaka",
      "Biratori",
      "Niikappu",
      "Urakawa",
      "Samani",
      "Erimo",
      "Shinhidaka",
      "Otofuke",
      "Shihoro",
      "Kamishihoro",
      "Shikaoi",
      "Shintoku",
      "Shimizu",
      "Memuro",
      "Nakasatsunai",
      "Sarabetsu",
      "Taiki",
      "Hiroo",
      "Makubetsu",
      "Ikeda",
      "Toyokoro",
      "Honbetsu",
      "Ashoro",
      "Rikubetsu",
      "Urahoro",
      "Akkeshi",
      "Hamanaka",
      "Shibecha",
      "Teshikaga",
      "Tsurui",
      "Shiranuka",
      "Betsukai",
      "Nakashibetsu",
      "Rausu",
      "Aomori",
      "Hirosaki",
      "Hachinohe",
      "Kuroishi",
      "Goshogawara",
      "Towada",
      "Misawa",
      "Mutsu",
      "Tsugaru",
      "Hirakawa",
      "Hiranai",
      "Imabetsu",
      "Yomogita",
      "Sotogahama",
      "Ajigasawa",
      "Fukaura",
      "Nishimeya",
      "Fujisaki",
      "Owani",
      "Inakadate",
      "Itayanagi",
      "Tsuruta",
      "Nakadomari",
    ];
    const DEFAULT_LANDMARK_LIST = [
      "Arakurayama Sengen Park",
      "Oishi Park",
      "Gotemba Premium Outlets",
      "Konohana no Yu Onsen",
      "Fushimi Inari Taisha",
      "Nara Deer Park",
      "Tofukuji Temple",
      "Shibuya Sky",
      "Hachiko Statue",
      "Kodaiji Temple",
    ];

    try {
      const [c, l] = await Promise.all([
        citiesUrl ? fetch(citiesUrl).then((r) => r.json()) : null,
        landmarksUrl ? fetch(landmarksUrl).then((r) => r.json()) : null,
      ]);

      const fromJsonCities = Array.isArray(c) ? c.map((it) => it.name) : [];
      const fromJsonLandmarks = Array.isArray(l) ? l.map((it) => it.name) : [];

      const fromImageCities = Array.from(
        new Set(cityData.map((it) => it.name))
      );
      const fromImageLandmarks = Array.from(
        new Set(landmarkData.map((it) => it.name))
      );

      // Gabungkan: JSON (jika ada) + yang bergambar + fallback tambahan
      CITY_ALL = Array.from(
        new Set([...fromJsonCities, ...fromImageCities, ...DEFAULT_CITY_LIST])
      );

      LANDMARK_ALL = Array.from(
        new Set([
          ...fromJsonLandmarks,
          ...fromImageLandmarks,
          ...DEFAULT_LANDMARK_LIST,
        ])
      );
    } catch (e) {
      // Fallback total jika fetch gagal
      CITY_ALL = Array.from(
        new Set([...cityData.map((it) => it.name), ...DEFAULT_CITY_LIST])
      );
      LANDMARK_ALL = Array.from(
        new Set([
          ...landmarkData.map((it) => it.name),
          ...DEFAULT_LANDMARK_LIST,
        ])
      );
    }
  }

  // ===== LOAD & SAVE =====
  function loadAnswers() {
    localStorage.removeItem("itinerary_quiz_answers");
    answers = {};
  }
  function saveAnswers() {
    return;
  }

  // ===== CONDITIONAL HANDLING =====
  function parseShowIf(el) {
    const raw = el.getAttribute("data-show-if");
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }
  function conditionMet(condition) {
    for (const [key, values] of Object.entries(condition)) {
      const v = answers[key];
      if (Array.isArray(values)) {
        if (!values.includes(v)) return false;
      } else if (v !== values) return false;
    }
    return true;
  }
  function updateConditionalBlocks(slide) {
    const blocks = $$(".conditional-block", slide);
    blocks.forEach((block) => {
      const cond = parseShowIf(block);
      if (!cond) return;
      if (conditionMet(cond)) {
        block.style.display = "block";
        block.classList.add("expanded");
        $$(".counter-input", block).forEach((inp) => {
          if (inp.value === "" || isNaN(parseInt(inp.value))) {
            const min = parseInt(inp.getAttribute("min")) || 0;
            inp.value = inp.defaultValue || String(min);
          }
        });
      } else {
        block.style.display = "none";
        block.classList.remove("expanded");
        $$("input,select,textarea", block).forEach((i) => {
          if (i.type === "radio" || i.type === "checkbox") i.checked = false;
          delete answers[i.name];
        });
      }
    });
    adjustHeight();
    refreshNextState();
  }

  // ===== PROGRESS =====
  function computeProgress() {
    const totalSlides = slidesArr.length;
    if (totalSlides === 0) return 0;
    const totalAnsweredKeys = Object.keys(answers).length;
    if (totalAnsweredKeys === 0) return 0;
    if (currentIndex === totalSlides - 1) return 100;

    let answered = 0;
    slidesArr.forEach((slide) => {
      const inputs = $$("input,select,textarea", slide).filter((el) => el.name);
      const hasAnswer = inputs.some((el) => {
        const name = el.name;
        if (!(name in answers)) return false;
        const val = answers[name];
        if (Array.isArray(val)) return val.length > 0;
        return String(val).trim() !== "";
      });
      if (hasAnswer) answered++;
    });

    const percent = Math.round((answered / totalSlides) * 100);
    return Math.min(percent, 100);
  }
  function updateProgress() {
    const percent = computeProgress();
    progressBar.style.width = percent + "%";
    progressLabel.textContent = percent + "%";
    progressText.textContent = percent + "% selesai";
  }

  // ===== VALIDATION =====
  function isChipSlide(slide) {
    const id = slide?.dataset?.slideId;
    return id === "city_preference" || id === "landmark_preference";
  }
  function isSlideValid(slide) {
    if (!slide) return true;
    if (slide.hasAttribute("data-optional")) return true;

    if (isChipSlide(slide)) {
      const chipBoxes = $$(".selected-cities, .selected-landmarks", slide);
      let hasChip = false;
      chipBoxes.forEach((box) => {
        if (box.querySelectorAll(".chip").length > 0) hasChip = true;
      });
      return hasChip;
    }

    const inputs = $$("input,select,textarea", slide).filter(
      (el) => el.offsetParent !== null
    );
    let filled = inputs.some((el) =>
      el.type === "radio" || el.type === "checkbox"
        ? el.checked
        : (el.value || "").trim() !== ""
    );

    const chipBoxes = $$(".selected-cities, .selected-landmarks", slide);
    chipBoxes.forEach((chipBox) => {
      const hasChip = chipBox.querySelectorAll(".chip").length > 0;
      if (hasChip) filled = true;
    });

    // 🔒 Validasi khusus untuk Q7 (select waktu harus dipilih)
    if (slide.dataset.slideId === "needs") {
      const startSelect = slide.querySelector("#start-time");
      const endSelect = slide.querySelector("#end-time");
      const startFilled = startSelect && startSelect.value.trim() !== "";
      const endFilled = endSelect && endSelect.value.trim() !== "";
      if (!startFilled || !endFilled) return false;
    }

    // 🔒 Validasi khusus untuk Q9 (know_japantrips)
    if (slide.dataset.slideId === "know_japantrips") {
      const selected = slide.querySelector(
        'input[name="know_japantrips"]:checked'
      );
      if (!selected) return false;

      if (selected.id === "know-japantrips-lainnya") {
        const ta = slide.querySelector("#know-japantrips-notes textarea");
        if (!ta || ta.value.trim() === "") return false;
      }

      // tambahan: kalau sosmed, wajib pilih sub-sosmed
      if (selected.id === "know-japantrips-social") {
        const sosmedSelected = slide.querySelector(
          'input[name="know_japantrips_social"]:checked'
        );
        if (!sosmedSelected) return false;
      }
    }

    return filled;
  }

  // ===== VALIDATION HELPERS =====
  function isVisible(el) {
    if (!el) return false;
    const style = window.getComputedStyle(el);
    return (
      style.display !== "none" &&
      style.visibility !== "hidden" &&
      el.offsetParent !== null
    );
  }
  function hasValue(input) {
    if (!input) return false;
    const type = (input.type || "").toLowerCase();
    if (type === "radio") {
      const group = input.name
        ? document.querySelectorAll(
            `input[type="radio"][name="${CSS.escape(input.name)}"]`
          )
        : [input];
      return Array.from(group).some((r) => r.checked);
    }
    if (type === "checkbox") {
      if (input.name) {
        const group = document.querySelectorAll(
          `input[type="checkbox"][name="${CSS.escape(input.name)}"]`
        );
        return Array.from(group).some((c) => c.checked);
      }
      return input.checked;
    }
    if (input.tagName === "SELECT")
      return input.value != null && String(input.value).trim() !== "";
    if (type === "file") return input.files && input.files.length > 0;
    if (type === "number") {
      const v = input.value;
      if (v === "" || v == null) return false;
      if (input.hasAttribute("min") && Number(v) < Number(input.min))
        return false;
      if (input.hasAttribute("max") && Number(v) > Number(input.max))
        return false;
      return true;
    }
    return String(input.value || "").trim() !== "";
  }
  function validateCurrentSlide() {
    const slide = slidesArr[currentIndex];
    if (!slide) return true;
    if (slide.hasAttribute("data-optional")) return true;

    const requiredFields = slide.querySelectorAll(
      "[data-required-when-visible]"
    );
    for (const field of requiredFields) {
      const expandBlock =
        field.closest("[data-expand-block]") ||
        field.closest("[data-expanded]") ||
        field.parentElement;
      if (expandBlock && !isVisible(expandBlock)) continue;
      if (!isVisible(field)) continue;
      if (!hasValue(field)) return false;
    }
    return true;
  }

  function setNextEnabled(enabled) {
    const activeSlide = slidesArr[currentIndex];
    const localBtn = activeSlide ? $(".next", activeSlide) : null;
    const globalBtn = document.querySelector(
      "[data-quiz-next], .quiz-next, .btn-next, button.next"
    );
    const nextBtn = localBtn || globalBtn;
    if (!nextBtn) return;

    if (enabled) {
      nextBtn.removeAttribute("disabled");
      nextBtn.classList.remove("is-disabled");
      nextBtn.setAttribute("aria-disabled", "false");
      nextBtn.style.opacity = "";
      nextBtn.style.cursor = "";
      nextBtn.style.pointerEvents = "";
      nextBtn.style.filter = "";
    } else {
      nextBtn.setAttribute("disabled", "disabled");
      nextBtn.classList.add("is-disabled");
      nextBtn.setAttribute("aria-disabled", "true");
      nextBtn.style.opacity = "0.45";
      nextBtn.style.cursor = "not-allowed";
      nextBtn.style.pointerEvents = "none";
      nextBtn.style.filter = "grayscale(0.2)";
    }
  }
  function refreshNextState() {
    const slide = slidesArr[currentIndex];
    const allowed = isSlideValid(slide) && validateCurrentSlide();
    setNextEnabled(allowed);
  }
  function updateUI() {
    slidesArr.forEach((s, i) => {
      s.classList.toggle("active", i === currentIndex);
    });
    adjustHeight();
    updateProgress();
    refreshNextState();
  }
  function adjustHeight() {
    const active = slidesArr[currentIndex];
    if (active) wrapper.style.height = active.scrollHeight + "px";
  }

  function scrollToTop() {
    const rootEl = document.querySelector(".itinerary-quiz");
    if (!rootEl) return;

    rootEl.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }

  function nextSlide() {
    if (!validateCurrentSlide()) {
      const slide = slidesArr[currentIndex];
      const msg =
        slide?.querySelector("[data-required-message]") ||
        document.querySelector("[data-global-required-message]");
      if (msg) {
        msg.textContent = "Lengkapi bagian yang terbuka dulu ya 😊";
        msg.classList.add("show");
        setTimeout(() => msg.classList.remove("show"), 2500);
      }
      refreshNextState();
      return;
    }
    const currentSlide = slidesArr[currentIndex];
    collectAnswers(currentSlide);
    if (currentIndex < slidesArr.length - 1) {
      currentIndex++;
      updateUI();
      scrollToTop(); // ✅ Tambahkan baris ini
      generateSummary();
    }
  }

  function prevSlide() {
    const currentSlide = slidesArr[currentIndex];
    collectAnswers(currentSlide);
    if (currentIndex > 0) {
      currentIndex--;
      updateUI();
      scrollToTop(); // ✅ Tambahkan juga di sini
      generateSummary();
    }
  }

  // ===== ANSWER COLLECTION =====
  function collectAnswers(slide) {
    const inputs = $$("input,select,textarea", slide);

    // track grup radio di slide ini
    const radioGroups = {};

    inputs.forEach((i) => {
      if (i.hasAttribute("data-chip-input")) return;

      if (i.type === "radio") {
        if (!i.name) return;
        if (!(i.name in radioGroups)) radioGroups[i.name] = false;

        if (i.checked) {
          answers[i.name] = i.value;
          radioGroups[i.name] = true;
        }
      } else if (i.type === "checkbox") {
        if (!Array.isArray(answers[i.name])) answers[i.name] = [];
        if (i.checked && !answers[i.name].includes(i.value))
          answers[i.name].push(i.value);
        else if (!i.checked)
          answers[i.name] = answers[i.name].filter((v) => v !== i.value);
        if (answers[i.name].length === 0) delete answers[i.name];
      } else {
        const v = (i.value || "").trim();
        if (v) answers[i.name] = v;
        else delete answers[i.name];
      }
    });

    Object.keys(radioGroups).forEach((name) => {
      if (!radioGroups[name]) {
        delete answers[name];
      }
    });

    saveAnswers();
  }

  function setupSlides() {
    slidesArr.forEach((slide) => {
      const nextBtn = $(".next", slide);
      const backBtn = $(".back", slide);
      const inputs = $$("input,select,textarea", slide);

      function refresh() {
        const allowed = isSlideValid(slide) && validateCurrentSlide();
        if (nextBtn) nextBtn.disabled = !allowed;
        setNextEnabled(allowed);
        updateProgress();
      }

      inputs.forEach((input) => {
        input.addEventListener("change", () => {
          collectAnswers(slide);
          updateConditionalBlocks(slide);
          refresh();
          updateProgress();

          const hasExpanded =
            $$(".conditional-block.expanded", slide).length > 0;
          if (
            (input.type === "radio" || input.tagName === "SELECT") &&
            !hasExpanded
          ) {
            const currentSlide = input.closest(".slide");
            // 🚫 Kecualikan slide Q7 (needs) dan Q9 (know_japantrips)
            if (
              currentSlide &&
              (currentSlide.dataset.slideId === "needs" ||
                currentSlide.dataset.slideId === "know_japantrips")
            ) {
              return;
            }

            setTimeout(nextSlide, 250);
          }
        });

        // keep answers in sync while typing
        input.addEventListener("input", () => {
          collectAnswers(slide);
          updateConditionalBlocks(slide);
          refresh();
          updateProgress();
        });
      });

      nextBtn?.addEventListener("click", () => {
        collectAnswers(slide);
        updateConditionalBlocks(slide);
        if (isSlideValid(slide) && validateCurrentSlide()) nextSlide();
        else refreshNextState();
      });
      backBtn?.addEventListener("click", prevSlide);
    });
  }

  function setupCounters() {
    $$(".counter-btn", root).forEach((btn) => {
      const input = $(`[name="${btn.dataset.target}"]`, root);
      if (!input) return;

      let val = parseInt(input.value);
      if (isNaN(val)) {
        const min = parseInt(input.getAttribute("min")) || 0;
        input.value = min;
      }

      // ✅ Event klik tombol plus/minus
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const action = btn.dataset.action;
        let val = parseInt(input.value) || 0;
        const min = parseInt(input.getAttribute("min")) || 0;
        const max = parseInt(input.getAttribute("max")) || 999;

        if (action === "increase" && val < max) val++;
        else if (action === "decrease" && val > min) val--;

        input.value = val;
        answers[input.name] = String(val);
        saveAnswers();
        updateProgress();
        refreshNextState();
      });

      // ✅ Event ketik manual di input number
      input.addEventListener("input", () => {
        let val = parseInt(input.value) || 0;
        const min = parseInt(input.getAttribute("min")) || 0;
        const max = parseInt(input.getAttribute("max")) || 999;

        // batasi nilai manual agar tetap valid
        if (val < min) val = min;
        if (val > max) val = max;

        input.value = val;
        answers[input.name] = String(val);
        saveAnswers();
        updateProgress();
        refreshNextState();
      });
    });
  }

  // ===== SEARCH & CHIPS DENGAN FOTO =====
  // ===== SEARCH & CHIPS DENGAN FOTO (versi JSON eksternal + index prefix) =====
  function setupSearch(
    selector,
    chipContainer,
    listContainer,
    gridItems, // (diabaikan)
    allItems // (diabaikan)
  ) {
    const input = $(selector, root);
    const chipBox = $(chipContainer, root);
    const listBox = $(listContainer, root);
    if (!input || !chipBox || !listBox) return;

    input.setAttribute("data-chip-input", "1");
    const fieldName = listBox.dataset.name || input.name;

    if (answers[fieldName]) {
      if (typeof answers[fieldName] === "string") {
        answers[fieldName] = answers[fieldName]
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean);
      }
    }

    // Tipe & URL JSON dari <section class="itinerary-quiz" ...>
    const type = fieldName === "city_preference" ? "city" : "landmark";
    const dataUrl =
      type === "city" ? root.dataset.citiesUrl : root.dataset.landmarksUrl;

    // ========= util + cache (singleton supaya reuse di slide lain) =========
    const IQ = (window.__IQ_SEARCH__ ||= { DATA: {}, INDEX: {}, CTRL: {} });

    const norm =
      window.__iq_norm ||
      (window.__iq_norm = (s) =>
        String(s || "")
          .toLowerCase()
          .normalize("NFD")
          .replace(/\p{Diacritic}/gu, "")
          .replace(/\s+/g, " ")
          .trim());

    const debounce =
      window.__iq_debounce ||
      (window.__iq_debounce = function (fn, ms = 200) {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn(...args), ms);
        };
      });

    async function loadTypeOnce(t, url) {
      if (IQ.DATA[t]) return IQ.DATA[t];
      if (IQ.CTRL[t]) IQ.CTRL[t].abort();
      const ctrl = new AbortController();
      IQ.CTRL[t] = ctrl;
      const res = await fetch(url, {
        signal: ctrl.signal,
        cache: "force-cache",
      });
      if (!res.ok) throw new Error("Failed to load " + t);
      const json = await res.json();
      IQ.DATA[t] = json;
      return json;
    }

    function buildIndex(t, raw) {
      // INDEX: { list:[{l,a?}], keys:[[kw...]], p2:Map, p3:Map }
      const list = [];
      const keys = [];
      const p2 = new Map();
      const p3 = new Map();
      const push = (map, key, i) => {
        if (!key) return;
        const arr = map.get(key) || [];
        arr.push(i);
        map.set(key, arr);
      };

      if (t === "city") {
        // raw: ["Tokyo","Osaka",...]
        raw.forEach((label) => {
          const L = String(label || "").trim();
          if (!L) return;
          const i = list.length;
          list.push({ l: L });
          const k0 = norm(L);
          keys.push([k0]);
          push(p2, k0.slice(0, 2), i);
          push(p3, k0.slice(0, 3), i);
        });
      } else {
        // raw: [{l:"...", a:["..."]}, ...]
        raw.forEach((o) => {
          const L = String(o?.l || "").trim();
          if (!L) return;
          const i = list.length;
          list.push({ l: L, a: o.a || [] });
          const kws = [L, ...(o.a || [])].map(norm).filter(Boolean);
          const uniq = Array.from(new Set(kws));
          keys.push(uniq);
          const k0 = uniq[0] || "";
          push(p2, k0.slice(0, 2), i);
          push(p3, k0.slice(0, 3), i);
        });
      }
      IQ.INDEX[t] = { list, keys, p2, p3 };
      return IQ.INDEX[t];
    }

    async function ensureIndex(t, url) {
      if (IQ.INDEX[t]) return IQ.INDEX[t];
      const raw = await loadTypeOnce(t, url);
      return buildIndex(t, raw);
    }

    async function searchType(t, url, q, limit = 20) {
      const idx = await ensureIndex(t, url);
      const n = norm(q);
      if (n.length < 2) return [];
      const { list, keys, p2, p3 } = idx;

      const bucket3 = p3.get(n.slice(0, 3)) || [];
      const bucket2 = p2.get(n.slice(0, 2)) || [];
      const pool = bucket3.length
        ? bucket3
        : bucket2.length
          ? bucket2
          : keys.map((_, i) => i);

      const pref = [];
      const sub = [];

      for (const i of pool) {
        if (keys[i].some((k) => k.startsWith(n))) {
          pref.push(i);
          if (pref.length >= limit) break;
        }
      }
      if (pref.length < limit) {
        for (const i of pool) {
          if (pref.includes(i)) continue;
          if (keys[i].some((k) => k.includes(n))) {
            sub.push(i);
            if (pref.length + sub.length >= limit) break;
          }
        }
      }
      const picked = [...pref, ...sub].slice(0, limit);
      return picked.map((i) => list[i].l);
    }

    // ================== UI: GRID dgn foto (tetap seperti sebelumnya) ==================
    function renderList() {
      listBox.innerHTML = "";
      const data = fieldName === "city_preference" ? cityData : landmarkData;

      data.forEach((it) => {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "city-card";

        const arr = Array.isArray(answers[fieldName]) ? answers[fieldName] : [];
        if (arr.includes(it.name)) btn.classList.add("selected");

        btn.innerHTML = `
        <div class="card-img">
          <img src="${it.img}" alt="${it.name}" loading="lazy" />
        </div>
        <span class="card-text">${it.name}</span>
      `;
        btn.addEventListener("click", () => toggle(it.name));
        listBox.appendChild(btn);
      });
    }

    function toggle(it) {
      if (!Array.isArray(answers[fieldName])) answers[fieldName] = [];
      const arr = answers[fieldName];
      const idx = arr.indexOf(it);
      if (idx !== -1) arr.splice(idx, 1);
      else arr.push(it);
      renderChips();
      renderList();
      closeSuggestions();
      saveAnswers();
      updateProgress();
      refreshNextState();
    }

    function renderChips() {
      chipBox.innerHTML = "";
      const arr = Array.isArray(answers[fieldName]) ? answers[fieldName] : [];
      arr.forEach((it) => {
        const chip = document.createElement("span");
        chip.className = "chip";
        chip.innerHTML = `
        <span class="chip-text">${it}</span>
        <button type="button" class="chip-remove" aria-label="Hapus ${it}">×</button>
      `;
        chip.querySelector(".chip-remove").addEventListener("click", (e) => {
          e.stopPropagation();
          toggle(it);
        });
        chipBox.appendChild(chip);
      });
    }

    // ================== Suggestion box (pakai data JSON + index) ==================
    let suggestionBox = document.createElement("div");
    suggestionBox.className = "search-suggestions";
    input.parentNode.appendChild(suggestionBox);

    let currentMatches = [];

    function paintSuggestions(list) {
      suggestionBox.innerHTML = "";
      const keyword = input.value.trim();

      // 1. Jika user ngetik sesuatu yang belum ada → tampilkan paling atas
      if (keyword && !list.includes(keyword)) {
        const addOpt = document.createElement("div");
        addOpt.className = "suggestion-item add-new";
        addOpt.innerHTML = `
          <span style="flex:1">${keyword}</span>
          <strong style="margin-left:auto; font-weight:700">+</strong>
        `;
        addOpt.style.display = "flex";
        addOpt.style.alignItems = "center";
        addOpt.style.borderBottom = "1px dashed #ccc";
        addOpt.addEventListener("click", () => {
          toggle(keyword);
          input.value = "";
          closeSuggestions();
          input.focus();
        });
        suggestionBox.appendChild(addOpt);
      }

      // 2. Lanjutkan hasil suggestion asli
      if (list && list.length > 0) {
        list.slice(0, 20).forEach((m) => {
          const opt = document.createElement("div");
          opt.className = "suggestion-item";
          opt.textContent = m;
          opt.addEventListener("click", () => {
            toggle(m);
            input.value = "";
            closeSuggestions();
            input.focus();
          });
          suggestionBox.appendChild(opt);
        });
      }

      if (suggestionBox.innerHTML === "") return closeSuggestions();
      suggestionBox.style.display = "block";
    }

    function closeSuggestions() {
      suggestionBox.style.display = "none";
    }

    const debouncedSuggest = debounce(async () => {
      const q = input.value.trim();
      if (!q) return closeSuggestions();
      try {
        currentMatches = await searchType(type, dataUrl, q, 20);
        paintSuggestions(currentMatches);
      } catch {
        // jika gagal fetch / index, tutup saja
        closeSuggestions();
      }
    }, 200);

    input.addEventListener("input", debouncedSuggest);

    // ✅ Enter: terima kalau exact match (case-insensitive) atau hanya 1 suggestion
    input.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        const val = (input.value || "").trim();
        if (!val) return;

        const lower = norm(val);
        const exact = currentMatches.find((n) => norm(n) === lower) || null;

        if (exact) {
          toggle(exact);
          input.value = "";
          closeSuggestions();
          return;
        }

        if (currentMatches.length === 1) {
          toggle(currentMatches[0]);
          input.value = "";
          closeSuggestions();
          return;
        }

        // kalau tidak match, abaikan
        input.classList.add("invalid-input");
        setTimeout(() => input.classList.remove("invalid-input"), 800);
      }
    });

    // Prefetch index saat fokus pertama kali (biar responsif)
    let preloaded = false;
    input.addEventListener("focus", async () => {
      if (preloaded) return;
      preloaded = true;
      try {
        await ensureIndex(type, dataUrl);
      } catch {}
    });

    document.addEventListener("click", (e) => {
      if (!suggestionBox.contains(e.target) && e.target !== input) {
        closeSuggestions();
      }
    });

    renderList();
    renderChips();
  }

  // ===== SUMMARY =====
  function generateSummary() {
    const summaryEl = $("#answers-summary", root);
    if (!summaryEl) return;

    const labels = {
      been_to_japan: "Pernah ke Jepang",
      travel_with: "Bepergian dengan",
      have_ticket: "Status tiket pesawat",
      ticket_file: "File tiket",
      ticket_plan: "Rencana keberangkatan",
      estimated_departure: "Perkiraan tanggal berangkat",
      estimated_return: "Perkiraan tanggal pulang",
      travel_season: "Musim perjalanan",
      duration: "Durasi perjalanan",
      travellers_type: "Tipe traveler",
      adult: "Jumlah Dewasa (18+)",
      child: "Jumlah Anak (4-17)",
      toddler: "Jumlah Balita (0-3)",
      destinations: "Jenis aktivitas",
      city_preference: "Kota tujuan",
      landmark_preference: "Landmark & Theme Park",
      start_time: "Jam mulai",
      end_time: "Jam selesai",
      needs: "Preferensi & kebutuhan khusus",
      notes: "Catatan tambahan",
      know_japantrips: "Sumber mengetahui Japantrips",
      know_japantrips_social: "Detail sosial media",
      know_japantrips_notes: "Sumber lainnya",
    };

    let html = "";

    Object.keys(answers).forEach((key) => {
      if (!labels[key]) return;

      // Khusus detail sosial media:
      // cuma tampil kalau sumber utama = "Social Media"
      if (
        key === "know_japantrips_social" &&
        answers.know_japantrips !== "Social Media"
      ) {
        return;
      }

      let value = answers[key];
      if (Array.isArray(value)) value = value.join(", ");

      if (key === "duration") {
        if (value === "-" || value === "" || Number(value) <= 0) return;
        value = `${value} hari`;
      }

      // Opsional: skip any '-' placeholders
      if (value === "-" || value === null || value === undefined) return;

      html += `
      <div class="summary-item">
        <span class="summary-label">${labels[key]}</span>
        <span class="summary-value">${value}</span>
      </div>
    `;
    });

    // extra notes (tetap seperti semula)
    const extraNotes = [];
    const destTextarea = document.querySelector("#destinations-notes textarea");
    const destCheckbox = document.querySelector("#destinations-lainnya");
    if (destCheckbox?.checked && destTextarea?.value.trim()) {
      extraNotes.push({
        label: "Aktivitas lainnya",
        value: destTextarea.value.trim(),
      });
    }
    const needsTextarea1 = document.querySelector("#needs-notes-1 textarea");
    const needsCheckbox1 = document.querySelector("#needs-lainnya-1");
    if (needsCheckbox1?.checked && needsTextarea1?.value.trim()) {
      extraNotes.push({
        label: "Kebutuhan khusus lainnya (1)",
        value: needsTextarea1.value.trim(),
      });
    }
    const needsTextarea2 = document.querySelector("#needs-notes-2 textarea");
    const needsCheckbox2 = document.querySelector("#needs-lainnya-2");
    if (needsCheckbox2?.checked && needsTextarea2?.value.trim()) {
      extraNotes.push({
        label: "Kebutuhan khusus lainnya (2)",
        value: needsTextarea2.value.trim(),
      });
    }

    const knowTextarea = document.querySelector(
      "#know-japantrips-notes textarea"
    );
    const knowCheckbox = document.querySelector("#know-japantrips-lainnya");
    if (knowCheckbox?.checked && knowTextarea?.value.trim()) {
      extraNotes.push({
        label: "Darimana mengetahui Japantrips (lainnya)",
        value: knowTextarea.value.trim(),
      });
    }

    extraNotes.forEach((item) => {
      html += `
      <div class="summary-item">
        <span class="summary-label">${item.label}</span>
        <span class="summary-value">${item.value}</span>
      </div>
    `;
    });

    summaryEl.innerHTML = html;
  }

  function setupCharacterCounters() {
    const textareas = $$("textarea", root);
    textareas.forEach((ta) => {
      const hint = ta.closest(".form-group")?.querySelector(".form-hint");
      if (!hint) return;

      function updateCount() {
        const len = ta.value.length;
        const max = ta.getAttribute("maxlength") || 500;
        hint.textContent = `${len} / ${max} karakter`;
      }
      updateCount();
      ta.addEventListener("input", updateCount);
    });
  }

  async function init() {
    loadAnswers();
    setupSlides();
    setupCounters();

    // ⬇️ Muat superset untuk autocomplete
    await loadAutoCompleteUniverse(root);

    // ⬇️ Pakai superset agar suggestion tak terbatas yang bergambar
    setupSearch(
      "#citySearch",
      "#selectedCities",
      "#cityList",
      cityData,
      CITY_ALL // <— sebelumnya cityData.map(c=>c.name)
    );
    setupSearch(
      "#landmarkSearch",
      "#selectedLandmarks",
      "#landmarkList",
      landmarkData,
      LANDMARK_ALL // <— sebelumnya landmarkData.map(l=>l.name)
    );

    setupCharacterCounters();
    slidesArr.forEach(updateConditionalBlocks);
    updateUI();
    generateSummary();

    window.answers = answers;
  }

  init();
})();

document.addEventListener(
  "focus",
  function (event) {
    if (event.target.type === "date") {
      if (event.target.showPicker) event.target.showPicker();
      else event.target.focus();
    }
  },
  true
);

document.addEventListener("click", function (event) {
  if (event.target.type === "time") {
    if (event.target.showPicker) event.target.showPicker();
    else event.target.focus();
  }
});

document.addEventListener("change", function (e) {
  const t = e.target;
  if (!t) return;

  // toggle untuk destinations-lainnya
  if (t.id === "destinations-lainnya") {
    const notes = document.getElementById("destinations-notes");
    if (!notes) return;
    notes.classList.toggle("hidden", !t.checked);
    if (!t.checked) notes.querySelector("textarea").value = "";
  }

  // toggle untuk needs-lainnya-1
  if (t.id === "needs-lainnya-1") {
    const notes = document.getElementById("needs-notes-1");
    if (!notes) return;
    notes.classList.toggle("hidden", !t.checked);
    if (!t.checked) notes.querySelector("textarea").value = "";
  }

  // toggle untuk needs-lainnya-2
  if (t.id === "needs-lainnya-2") {
    const notes = document.getElementById("needs-notes-2");
    if (!notes) return;
    notes.classList.toggle("hidden", !t.checked);
    if (!t.checked) notes.querySelector("textarea").value = "";
  }

  // ✅ toggle untuk know_japantrips-lainnya
  if (t.id === "know-japantrips-lainnya") {
    const notes = document.getElementById("know-japantrips-notes");
    if (!notes) return;
    notes.classList.toggle("hidden", !t.checked);
    if (!t.checked) notes.querySelector("textarea").value = "";
  }
  // toggle sublist untuk "Sosial Media"
  if (t.name === "know_japantrips") {
    const socialWrapper = document.getElementById(
      "know-japantrips-social-options"
    );
    if (socialWrapper) {
      const selected = document.querySelector(
        'input[name="know_japantrips"]:checked'
      );
      const isSocial = selected && selected.id === "know-japantrips-social";

      socialWrapper.classList.toggle("hidden", !isSocial);

      // Kalau bukan sosial media, kosongkan pilihan sub-sosmed
      if (!isSocial) {
        socialWrapper
          .querySelectorAll('input[name="know_japantrips_social"]')
          .forEach((el) => (el.checked = false));
      }
    }
  }
});

function collectChips(containerSel) {
  return Array.from(
    document.querySelectorAll(`${containerSel} .chip .chip-text`)
  )
    .map((el) => el.textContent.trim())
    .filter(Boolean);
}

function dedupe(arr) {
  return Array.isArray(arr) ? arr.filter((v, i, a) => a.indexOf(v) === i) : arr;
}

function collectAllAnswersFromDOM() {
  const getVal = (sel) => {
    const el = document.querySelector(sel);
    return el ? (el.value || "").trim() : "";
  };

  // 🔹 Ambil nilai radio; kalau value kosong, fallback ke teks label (.option-text)
  const getCheckedVal = (name) => {
    const el = document.querySelector(`input[name="${name}"]:checked`);
    if (!el) return "";

    const raw = (el.value || "").trim();
    if (raw !== "") return raw;

    // fallback: pakai teks di dalam label
    const label = el.closest("label");
    const txt = label?.querySelector(".option-text")?.textContent?.trim() || "";
    return txt;
  };

  const getCheckedList = (name) => {
    return Array.from(
      document.querySelectorAll(`input[name="${name}"]:checked`)
    ).map((el) => el.value);
  };

  const cities = collectChips("#selectedCities");
  const landmarks = collectChips("#selectedLandmarks");

  const destLainnya = document.querySelector("#destinations-lainnya")?.checked
    ? getVal("#destinations-notes textarea")
    : "";

  const needsLain1 = document.querySelector("#needs-lainnya-1")?.checked
    ? getVal("#needs-notes-1 textarea")
    : "";

  const needsLain2 = document.querySelector("#needs-lainnya-2")?.checked
    ? getVal("#needs-notes-2 textarea")
    : "";

  const knowJapantripsNotes = document.querySelector("#know-japantrips-lainnya")
    ?.checked
    ? document.querySelector("#know-japantrips-notes textarea")?.value.trim() ||
      "-"
    : "-";

  const ticketFileInput = document.querySelector('input[name="ticket_file"]');
  const fileFakePath =
    ticketFileInput?.files?.[0]?.name || ticketFileInput?.value || "";
  const ticket_file_url = window.uploadedFileUrl || "";

  const needs = dedupe(getCheckedList("needs"));

  // 🔹 Logic khusus Q9
  const knowJapantrips = getCheckedVal("know_japantrips");
  const knowJapantripsSocial =
    knowJapantrips === "Social Media"
      ? getCheckedVal("know_japantrips_social")
      : "";

  const data = {
    timestamp: new Date().toISOString(),
    fullname: getVal('input[name="fullname"]'),
    email: getVal('input[name="email"]'),
    been_to_japan: getCheckedVal("been_to_japan"),
    travel_with: getCheckedVal("travel_with"),
    have_ticket: getCheckedVal("have_ticket"),
    ticket_file: fileFakePath || "-",
    ticket_file_url: ticket_file_url || fileFakePath || "-",
    ticket_plan: getCheckedVal("ticket_plan"),
    estimated_departure: getVal('input[name="estimated_departure"]'),
    estimated_return: getVal('input[name="estimated_return"]'),
    travel_season: getVal('select[name="travel_season"]'),
    // durasi otomatis "-" kalau kosong atau field tidak terlihat
    duration: (() => {
      const el = document.querySelector('input[name="duration"]');
      if (!el || el.offsetParent === null) return "-";
      const v = el.value?.trim() || "";
      return v === "" ? "-" : v;
    })(),
    travellers_type: getCheckedVal("travellers_type"),
    adult: getVal('input[name="adult"]'),
    child: getVal('input[name="child"]'),
    toddler: getVal('input[name="toddler"]'),
    destinations: getCheckedList("destinations"),
    destinations_notes: destLainnya,
    city_preference: cities,
    landmark_preference: landmarks,
    start_time: getVal("#start-time"),
    end_time: getVal("#end-time"),
    needs,
    needs_notes_1: needsLain1,
    needs_notes_2: needsLain2,
    notes: getVal('textarea[name="notes"]'),
    know_japantrips: knowJapantrips,
    know_japantrips_social: knowJapantripsSocial,
    know_japantrips_notes: knowJapantripsNotes,
  };

  // 🔹 Normalisasi: kosong → "-"
  for (const key in data) {
    const val = data[key];
    if (val === "" || val == null || (Array.isArray(val) && val.length === 0))
      data[key] = "-";
  }

  return data;
}

// Helper: bikin nama aman
function makeSafeName(str) {
  return (str || "USER")
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/gi, "_")
    .replace(/^_+|_+$/g, "")
    .toUpperCase();
}

function nextLocalIndex() {
  const k = "itin_upload_index";
  const n = parseInt(localStorage.getItem(k) || "0", 10) + 1;
  localStorage.setItem(k, String(n));
  return n;
}

async function uploadTicketFile(file) {
  if (!file) return "";

  try {
    // Ambil nama pengupload dari form
    const fullName =
      document.querySelector('input[name="fullname"]')?.value || "USER";
    const base = makeSafeName(fullName);

    // Tentukan ekstensi asli
    const extMatch = (file.name || "").match(/\.([a-z0-9]+)$/i);
    const ext = extMatch ? `.${extMatch[1].toLowerCase()}` : "";

    // Buat index (sementara dari localStorage). Lebih mantap: minta dari server.
    const idx = String(nextLocalIndex()).padStart(3, "0");

    // Format akhir
    const desiredName = `${base}_INV_FORM_ITIN_${ext}`;

    // Siapkan FormData, set filename di parameter ke-3
    const formData = new FormData();
    formData.append("file", file, desiredName);
    // kirim juga agar backend bisa pakai memastikan nama di Shopify
    formData.append("desired_name", desiredName);

    const res = await fetch("https://upload.gkomunika.com/upload", {
      method: "POST",
      body: formData,
    });

    const result = await res.json();
    if (result.success && result.url) {
      window.uploadedFileUrl = result.url;
      return result.url;
    } else {
      console.warn("Upload gagal:", result.error);
      return "";
    }
  } catch (err) {
    console.error("Gagal upload file:", err);
    return "";
  }
}

// ======== KIRIM DATA KE SERVER VPS ========
async function submitItineraryToServer(formData) {
  try {
    const response = await fetch("https://upload.gkomunika.com/submit-form", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });
    const result = await response.json();
    if (result.success) {
      console.log("✅ Data berhasil dikirim ke Google Sheets via VPS");
      alert("Terima kasih! Jawabanmu sudah kami terima 😊");
      return true;
    } else {
      console.error("❌ Gagal kirim:", result.error);
      alert("Gagal mengirim data silahkan coba lagi");
      return false;
    }
  } catch (err) {
    console.error("⚠️ Error koneksi ke VPS:", err);
    alert("Terjadi kesalahan koneksi ke server, coba lagi nanti.");
    return false;
  }
}

// ======== FINAL SUBMIT HANDLER ========
(function setupFinalSubmit() {
  const btn = document.getElementById("iq-confirm-yes");
  if (!btn) return;
  if (btn.dataset.bound === "1") return;
  btn.dataset.bound = "1";

  const finalBackBtn = document.querySelector(".slide-final .btn-back.back");

  let inFlight = false;

  btn.addEventListener("click", async (e) => {
    e.preventDefault();
    if (inFlight) return;
    inFlight = true;

    const originalText = btn.textContent;
    btn.textContent = "Mengirim...";
    btn.disabled = true;

    const fileInput = document.querySelector('input[name="ticket_file"]');
    if (fileInput?.files?.[0]) {
      const uploadedUrl = await uploadTicketFile(fileInput.files[0]);
      window.uploadedFileUrl = uploadedUrl;
    }

    const payload = collectAllAnswersFromDOM();
    payload.submission_id =
      Date.now().toString(36) + Math.random().toString(36).slice(2, 8);

    console.log("📤 Mengirim data ke VPS:", payload);

    let success = false;
    try {
      success = await submitItineraryToServer(payload);
    } finally {
      if (!success) {
        btn.textContent = originalText;
        btn.disabled = false;
        inFlight = false;
      } else {
        btn.textContent = originalText;
        btn.disabled = true;
        if (finalBackBtn) finalBackBtn.disabled = true;
      }
    }
  });
})();
